<iframe #iframe [src]="plotSrc" scrolling="no"></iframe>
